import { Component, h, State, Prop, Method, Event, EventEmitter, Fragment } from '@stencil/core';
import ChevronIcon from '../../assets/icons/chevron-forward.svg';
import ArrowIcon from '../../assets/icons/arrow-forward-outline.svg';
import { Breakpoint, ModalState } from '../modal/modal';

@Component({
  tag: 'app-launch-slider',
  styleUrl: 'slider.css',
  shadow: true,
})
export class Slider {
  @State() currentItem: number = 0;
  @Prop() slides: { title: string; paragraph: string; imageSrc: string; imageAlt: string }[];
  @Prop() ctaPrimary: string;
  @Prop() ctaSecondary: string;
  @Prop() ctaTertiary: string;
  @Prop() ctaPrimaryTargetUrl: string;
  @Prop() ctaSecondaryTargetUrl: string;
  @Prop() ctaTertiaryTargetUrl: string;
  @Prop() breakpoint: Breakpoint = Breakpoint.Desktop;
  @Prop() modalState: ModalState = ModalState.Initial;

  @Prop() qrCodeSrc: string;
  @Prop() qrCodeCta: string;
  @Prop() playStoreImageSrc: string;
  @Prop() playStoreUrl: string;
  @Prop() appStoreImageSrc: string;
  @Prop() appStoreUrl: string;

  @Event() animationReady: EventEmitter;
  @Event({ bubbles: false, composed: false }) slideChanged: EventEmitter<number>;
  @Event() sliderEnd: EventEmitter;
  @Event() sliderEndStart: EventEmitter;

  @Event({ bubbles: false, composed: false }) ctaPrimaryClicked: EventEmitter;
  @Event({ bubbles: false, composed: false }) ctaSecondaryClicked: EventEmitter;
  @Event({ bubbles: false, composed: false }) ctaTertiaryClicked: EventEmitter;
  @Event({ bubbles: false, composed: false }) playStoreClicked: EventEmitter;
  @Event({ bubbles: false, composed: false }) appStoreClicked: EventEmitter;

  @Method() async jumpToLastSlide() {
    if (this.breakpoint === Breakpoint.Desktop) {
      this.sliderEndStart.emit();
    }
  }

  @Method() async refreshSlider() {
    this.currentItem = 0;
  }

  // private runTimedSlider: NodeJS.Timeout;
  // private isTimerRunning: boolean = false;

  // connectedCallback() {
  //   // if (this.breakpoint !== Breakpoint.Desktop) {
  //   //   if (this.runTimedSlider) {
  //   //     clearInterval(this.runTimedSlider);
  //   //     this.isTimerRunning = false;
  //   //   }
  //   //   setTimeout(() => {
  //   //     this.runTimedSlider = setInterval(this.timeSlider.bind(this), 2000);
  //   //   }, 1500);
  //   //   this.isTimerRunning = true;
  //   // }
  // }

  // private timeSlider() {
  //   if (this.currentItem < this.slides.length - 1) {
  //     this.currentItem++;
  //   } else {
  //     this.currentItem++;
  //     setTimeout(() => {
  //       this.currentItem = 0;
  //     }, 1000);
  //   }
  // }

  componentWillRender() {
    if (this.modalState === ModalState.Initial) {
      this.animationReady.emit();
    }

    // if (this.breakpoint === Breakpoint.Desktop && this.runTimedSlider) {
    //   clearInterval(this.runTimedSlider);
    //   this.isTimerRunning = false;
    // }
    // if (this.breakpoint !== Breakpoint.Desktop && !this.isTimerRunning) {
    //   this.runTimedSlider = this.runTimedSlider = setInterval(this.timeSlider.bind(this), 2000);
    //   this.isTimerRunning = true;
    // }
  }

  private handleSlideChange(direction) {
    if (direction > 0 && this.currentItem < this.slides.length - 1) {
      this.currentItem++;
      this.slideChanged.emit(this.currentItem);
    } else if (direction < 0 && this.currentItem > 0) {
      this.currentItem--;
      this.slideChanged.emit(this.currentItem);
    } else if (direction > 0 && this.currentItem === this.slides.length - 1) {
      if (this.breakpoint === Breakpoint.Desktop) {
        this.sliderEndStart.emit();
      }
    }
  }

  private handleSlideOut(event) {
    if (this.modalState === ModalState.SliderFinishing && event.target === event.currentTarget) {
      this.sliderEnd.emit();
    }
  }

  private getSlideClass(slideIndex: number, currentIndex: number) {
    return `slider-image-item ${
      slideIndex === currentIndex - 2
        ? 'previous-previous'
        : slideIndex === currentIndex - 1
        ? 'previous'
        : slideIndex === currentIndex
        ? 'current'
        : slideIndex === currentIndex + 1
        ? 'next'
        : slideIndex === currentIndex + 2
        ? 'next-next'
        : 'hidden'
    } ${currentIndex === 0 ? 'initial' : ''}`;
  }

  render() {
    return (
      <div
        id="slider-container"
        class={`${this.modalState !== ModalState.Initial ? 'animated' : ''} ${this.modalState === ModalState.Refreshed ? 'refreshed' : ''} ${
          this.modalState === ModalState.SliderFinished || this.modalState === ModalState.SliderFinishing || this.modalState === ModalState.Refreshing ? 'ended' : ''
        }`}
      >
        <button
          class="icon-button previous"
          disabled={this.currentItem <= 0 || (this.modalState !== ModalState.Started && this.modalState !== ModalState.Refreshed)}
          onClick={this.handleSlideChange.bind(this, -1)}
        >
          <i class="icon" innerHTML={ChevronIcon}></i>
        </button>
        <div id="slider-content">
          <div id="slider-texts">
            <div class="fill-container"></div>
            {this.modalState !== ModalState.SliderFinished && this.modalState !== ModalState.Refreshing ? (
              <div id="slides-content-container" onAnimationEnd={this.handleSlideOut.bind(this)}>
                <div class="slider-text-items-container" style={{ transform: `translateX(calc(${-100 * this.currentItem}% - ${8 * this.currentItem}px))` }}>
                  {this.slides.map((slide, index) => {
                    return (
                      <div class={`slider-text-item ${this.currentItem === index ? 'current' : ''}`}>
                        <h3 class="slide-title">{slide.title}</h3>
                        <p class="slide-paragraph">{slide.paragraph}</p>
                      </div>
                    );
                  })}
                </div>
                {this.breakpoint === Breakpoint.Desktop && (
                  <Fragment>
                    <div id="buttons-container">
                      <app-launch-button
                        label={this.ctaPrimary}
                        variant="filled"
                        id="button-primary"
                        isLink={this.breakpoint !== Breakpoint.Desktop}
                        href={this.breakpoint !== Breakpoint.Desktop && this.ctaPrimaryTargetUrl}
                        targetBlank
                        onClick={() => {
                          this.ctaPrimaryClicked.emit();
                          this.jumpToLastSlide();
                        }}
                      ></app-launch-button>
                      <app-launch-button
                        label={this.ctaSecondary}
                        variant="ghost"
                        id="button-secondary"
                        isLink
                        href={this.ctaSecondaryTargetUrl}
                        targetBlank
                        onClick={() => {
                          this.ctaSecondaryClicked.emit();
                        }}
                      ></app-launch-button>
                    </div>
                    <div id="cta-appuntamento-container" key="cta-appuntamento-1">
                      <p id="cta-appuntamento">Non sei ancora nostro Cliente?</p>{' '}
                      <app-launch-text-button
                        label={this.ctaTertiary}
                        iconDx={ArrowIcon}
                        isLink
                        href={this.ctaTertiaryTargetUrl}
                        targetBlank
                        onClick={() => {
                          this.ctaTertiaryClicked.emit();
                        }}
                      ></app-launch-text-button>
                    </div>
                  </Fragment>
                )}
              </div>
            ) : (
              <div id="last-slide-container" class={this.modalState === ModalState.Refreshing ? 'refreshing' : ''}>
                <h3 class="last-slide-title">{this.qrCodeCta}</h3>
                <div id="app-links">
                  <app-launch-store-button
                    href={this.playStoreUrl}
                    imageSrc={this.playStoreImageSrc}
                    onClick={() => {
                      this.playStoreClicked.emit();
                    }}
                  ></app-launch-store-button>
                  <app-launch-store-button
                    href={this.appStoreUrl}
                    imageSrc={this.appStoreImageSrc}
                    onClick={() => {
                      this.appStoreClicked.emit();
                    }}
                  ></app-launch-store-button>
                </div>
                <div id="cta-appuntamento-container" key="cta-appuntamento-2">
                  <p id="cta-appuntamento">Non sei ancora nostro Cliente?</p>{' '}
                  <app-launch-text-button
                    label={this.ctaTertiary}
                    iconDx={ArrowIcon}
                    isLink
                    href={this.ctaTertiaryTargetUrl}
                    targetBlank
                    onClick={() => {
                      this.ctaTertiaryClicked.emit();
                    }}
                  ></app-launch-text-button>
                </div>
              </div>
            )}
          </div>
          <div id="slider-images">
            <div id="slider-images-background" class={this.modalState === ModalState.Refreshing ? 'refreshing' : ''}>
              <div id="background-bubble-1"></div>
              <div id="background-bubble-2"></div>
              <div id="background-bubble-3"></div>
            </div>
            {this.modalState !== ModalState.SliderFinished && this.modalState !== ModalState.Refreshing ? (
              <div id="slider-image-items-container">
                {this.slides.map((slide, index) => {
                  return (
                    <div class={`slider-image-item ${this.getSlideClass(index, this.currentItem)}`}>
                      <img class="slider-image" src={slide.imageSrc} alt={slide.imageAlt ? slide.imageAlt : ''} />
                    </div>
                  );
                })}
              </div>
            ) : (
              <div id="qr-code-wrapper">
                <div class="fill-container"></div>
                <div id="qr-code-container" class={this.modalState === ModalState.Refreshing ? 'refreshing' : ''}>
                  <img src={this.qrCodeSrc} alt="codice QR per il download dell'app"></img>
                </div>
              </div>
            )}
          </div>
          {this.breakpoint !== Breakpoint.Desktop && (
            <Fragment>
              <div id="pagination">
                {this.slides.map((item, index) => {
                  return (
                    <div
                      class={`pagination-dot ${this.currentItem === index ? 'active' : ''}`}
                      key={`pagination-dot-${item.title}`}
                      onClick={() => {
                        this.currentItem = index;
                      }}
                    ></div>
                  );
                })}
              </div>
              <div id="cta-appuntamento-container" key="cta-appuntamento-2">
                <span id="cta-appuntamento">Non sei ancora nostro Cliente?</span>{' '}
                <a
                  class="link"
                  href={this.ctaTertiaryTargetUrl}
                  target="_blank"
                  rel="noreferrer noopener"
                  onClick={() => {
                    this.ctaTertiaryClicked.emit();
                  }}
                >
                  {this.ctaTertiary}
                </a>
              </div>
            </Fragment>
          )}
        </div>
        <button
          class="icon-button next"
          disabled={
            (this.modalState !== ModalState.Started && this.modalState !== ModalState.Refreshed) ||
            (this.breakpoint !== Breakpoint.Desktop && this.currentItem >= this.slides.length - 1)
          }
          onClick={this.handleSlideChange.bind(this, 1)}
        >
          <i class="icon" innerHTML={ChevronIcon}></i>
        </button>
      </div>
    );
  }
}
